// Third Party
import React, { Component } from 'react';
import { connect } from 'react-redux';

// Redux
import { ReduxState } from '../../../redux/modules/types';

// Components
import { FocusOverlay } from '../../components/layout';

type StateProps = {
  isComparisonFocused: boolean;
};

type Props = StateProps;

class ComparisonFocusOverlay extends Component<Props> {
  render() {
    const { isComparisonFocused } = this.props;

    if (isComparisonFocused) {
      return <FocusOverlay />;
    }

    return null;
  }
}

const mapStateToProps = (state: ReduxState) => {
  const isComparisonFocused = state.comparison.isFocused;

  return {
    isComparisonFocused,
  };
};

export default connect(mapStateToProps)(ComparisonFocusOverlay);
